import type { DatevExportType } from "@/features/settings/export-history/cells/exportType";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllExports = ({
  exportTypes,
  fetchPolicy,
}: {
  exportTypes?: (DatevExportType | null)[];
  fetchPolicy?: "network-only";
} = {}) => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery(DATEV_EXPORTS_QUERY, {
    variables: { tenantId, exportTypes },
    fetchPolicy,
  });

  return { exports: data?.exportHistory, error, loading, refetch };
};

export const DATEV_EXPORTS_QUERY = gql`
  query ExportHistory($exportTypes: [String!]) {
    exportHistory(exportTypes: $exportTypes) {
      datevExportId
      exportedAt
      invoiceIds
      supplierIds
      state
      exportType
      results
      stackName
      count
    }
  }
`;
